import { Row, Col } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Accounts: React.FC = () => {
  const navigation = useNavigate();

  // Handle Create New Account Click
  const handleCreateNewAccountClick = () => {    
    navigation("/newaccount", { state: { accountId: 0, contextName: null } });
  };

  // Render UI Component
  return (
    <div>
      <NavigationBar
        menuTitle="Configuration"
        title="Account"
        text="Account Configuration"
      />
      <Row>
        <Col xs={12}>
          <div
            className="rp-main-inner col-sm-12"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            {/* Buttons */}
            <div
              className="col-sm-5"
              style={{
                width: "100%",
                padding: "10px",
                textAlign: "right",
              }}
            >
              <Button
                variant="contained"
                size="small"
                onClick={handleCreateNewAccountClick}
                className="button createnew-button"              
              >
                Create New
              </Button>
            </div>
          </div>
          {/* Content  */}
          <div
            className="col-sm-12"
            style={{
              width: "100%",
              padding: "80px",
              color: "var(--aggrid-text-color)",
              textAlign: "center",
              fontSize: "20px",
            }}
          >
            Welcome to Account Configuration Module!!!
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default Accounts;
